<template lang="pug">
	.persistent-schedule-jobs-list.flex-col.space-large(:class="{ 'tb-padding': fullView }")
		ListView.full-width(ref="listView", initialView="table", :searchVisible="false", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadData", 
			:columns="columns", :filterRow="true")
			template(v-slot:resultJsonTemplate="{ data }")
				.result
					template(v-if="data.ResultCreativeId")
						a(@click="openObject(data.ResultCreativeId)") {{ $tCaption('Open creative') }}
					template(v-if="data.ResultError")
						.error {{ data.ResultError }}
			template(v-slot:nameTemplate="{ data }")
				a.flex-row.space.align-center(@click="openJob(data)")
					fas(icon="magnifying-glass")
					span {{ data.Name || data.Coede }}
			template(slot="left-actions")
				.font-big.upper {{ $tCaption('Persistent Jobs') }}
		Loader(v-if="isLoading", :fullscreen="true", text="")
		Popup(v-if="editingJobPopupVisible", :popupVisible.sync="editingJobPopupVisible", :width="920", :autosize="true", :title="$tCaption('Job details')")
			.flex-col
				JobDetail(:jobData="editingJob")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="editingJobPopupVisible = false")
</template>

<script>

import ListView from 'app-core/ListView.vue';
import DxButton from 'devextreme-vue/button';
import { 
	PERSISTENT_SCHEDULE_JOB_STATUS
} from 'app-core/constants';
import Loader from 'app-core/Loader';
import Popup from 'app-core/Popup.vue';
import JobDetail from './Detail.vue';

export default {
	translationCategory: 'persistent-schedule.List',
	components: { ListView, DxButton, Loader, Popup, JobDetail },
	props: ['scheduleId'],
	data() {
		const jobStatuses = PERSISTENT_SCHEDULE_JOB_STATUS.toLocale('name', this);
		return {
			jobStatuses,
			isLoading: false,
			editingJob: null,
			editingJobPopupVisible: false
		};
	},
	computed: {
		fullView() {
			return !this.scheduleId;
		},
		columns() {
			return [
				{ dataField: 'Name', caption: () => this.$tCaption('Name'), cellTemplate: 'nameTemplate' },
				{ dataField: 'Created', caption: () => this.$tCaption('Created'), dataType: 'date', format: 'yyyy-MM-dd hh:mm' },
				{ dataField: 'StatusChangedAt', caption: () => this.$tCaption('Status changed'), dataType: 'date', format: 'yyyy-MM-dd hh:mm' },
				{ dataField: 'Status', caption: () => this.$tCaption('Status'), lookup: {
					dataSource: this.jobStatuses,
					displayExpr: 'name',
					valueExpr: 'id'
				}},
				{ dataField: 'ResultJson', caption: () => this.$tCaption('Result'), cellTemplate: 'resultJsonTemplate' },
            ];
		}
	},
	mounted() {
		if (__DEBUG__)
			window.persistentScheduleJobsList = this;
	},
	destroyed() {
		
	},
	methods: {
		loadData(pageIndex, limit, opts) {
			let filter = opts?.filter || [];

			if (this.scheduleId) {
				if (filter.length) {
					filter = [
						['PersistentSchedule.Oid', '=', this.scheduleId],
						'and',
						filter
					]
				} else {
					filter = ['PersistentSchedule.Oid', '=', `${this.scheduleId}`];
				}
			}
			const filterCriteria = filter.length ? `&filterCriteria=${JSON.stringify(filter)}` : '';

			return this.$Data.getExternalApi('PersistentJobEntity/List', `page=${pageIndex + 1}${filterCriteria}&sorting=[{ selector: 'StatusChangedAt', desc: true }]`, limit)
				.then(r => {
					if (r.Results?.length) {
						r.Results.map(f => {
							const resultJson = (f.ResultJson && JSON.parse(f.ResultJson) || {});
							const statusData = (f.StatusData && JSON.parse(f.StatusData) || {});
							f.ResultCreativeId = (resultJson.ProcessedObjects || [])[0]?.ProcessedObjectId;
							f.ResultError = statusData?.ExceptionMessage;
						});
					}
					return r;
				});
		},
		openObject(creativeId) {
			const routeData = this.$router.resolve({ path: `/creative/Detail/${creativeId}` });
			window.open(routeData.href, '_blank');
		},
		openJob(data) {
			this.editingJob = data;
			this.editingJobPopupVisible = false;
			this.$nextTick(() => this.editingJobPopupVisible = true);
		}
	}
};
</script>
<style lang="scss">
	.persistent-schedule-list {
		
	}
</style>
